// import PutSimpatraServiceProxy from '@/proxies/back-end/simpatra-service/put';
import { get } from "lodash";
import PutSimpatraServiceProxy from "@/proxies/back-end/simpatra-service/put";
import PostSimpatraServiceProxy from "@/proxies/back-end/simpatra-service/post";
import GetSimpatraServiceProxy from "@/proxies/back-end/simpatra-service/get";
import DeleteSimpatraServiceProxy from "@/proxies/back-end/simpatra-service/delete";
import moduleConstructors from "../marketplaceModule/constructors";

const updateProduct = async ({ state }, { vendorId, payload }) => {
  const isBundleFlag = get(payload, "ispackage", false);
  const productId = state.productDetailsForm.id;

  const body = moduleConstructors.constructProductPayload(payload, isBundleFlag);
  const proxy = new PutSimpatraServiceProxy();
  const query = `products/v1/vendor/${vendorId}/product/${productId}`;
  const response = await proxy.execute(query, body, {
    displaySuccessMessage: true,
    successNotificationMsg: "Successfully updated product!",
  });
  if (response) {
    const { data } = response;
    if (data) {
      const resultsData = Object.assign({}, data);
      if (resultsData.productBundle.length > 0) {
        const value = [];
        resultsData.productBundle.forEach(product => {
          value.push(product.childProduct);
        });

        resultsData.productBundle = value;
        // commit("setProductFormDetails", resultsData);
      }

      return data;
    }
  } else {
    return null;
  }
};

const updateProductStocksStatus = async (_, { vendorId, productId, payload }) => {
  const proxy = new PostSimpatraServiceProxy();
  const query = `products/v1/vendor/${vendorId}/product/${productId}/stock`;
  const response = await proxy.execute(query, payload, {
    successNotificationMsg: `Product succesfully updated to ${payload.inStock ? "In Stock" : "Out of Stock"}`,
    displaySuccessMessage: true,
  });
  if (response) {
    const { data } = response;
    return data;
  }
};

const addNewProduct = async (_, { payload, vendorId }) => {
  const isBundleFlag = get(payload, "ispackage", false);

  const body = moduleConstructors.constructProductPayload(payload, isBundleFlag);
  const proxy = new PostSimpatraServiceProxy();
  const query = `products/v1/vendor/${vendorId}/product`;
  const response = await proxy.execute(query, body, {
    successNotificationMsg: "Successfully added product!",
    displaySuccessMessage: true,
  });
  if (response) {
    const { data } = response;
    return data;
  }
};

const addNewBundleProduct = async (_, { payload, vendorId }) => {
  const isBundleFlag = get(payload, "ispackage", false);

  const body = moduleConstructors.constructProductPayload(payload, isBundleFlag);
  const proxy = new PostSimpatraServiceProxy();
  const query = `products/v1/vendor/${vendorId}/product`;
  const response = await proxy.execute(query, body, {
    successNotificationMsg: "Successfully added product!",
    displaySuccessMessage: true,
  });
  if (response) {
    const { data } = response;
    const resultsData = Object.assign({}, data);
    if (resultsData.productBundle.length > 0) {
      const value = [];
      resultsData.productBundle.forEach(product => {
        value.push(product.childProduct);
      });

      resultsData.productBundle = value;
      // commit("setProductFormDetails", resultsData);
    }

    return data;
  }
};

const fetchVendorProducts = async (_, { queryParams, vendorId }) => {
  const proxy = new GetSimpatraServiceProxy();
  const query = `products/v1/vendor/${vendorId}/product`;
  const response = await proxy.execute(query, queryParams);
  if (response) {
    const { data } = response;
    return data;
  }
  return [];
};

const fetchVendorProductByProductId = async (_, payload) => {
  const proxy = new GetSimpatraServiceProxy();
  const { productId, vendorId } = payload;
  const query = `products/v1/vendor/${vendorId}/product/${productId}`;
  const response = await proxy.execute(query);
  if (response) {
    const { data } = response;
    return data;
  }
  return null;
};

const fetchVendorTiers = async ({ commit }, vendorId) => {
  const proxy = new GetSimpatraServiceProxy();
  const query = `products/v1/vendor/${vendorId}/tier`;
  const response = await proxy.execute(query);
  if (response) {
    const { data } = response;
    commit("setVendorTiers", data);
    return data;
  }
};

const addVendorTier = async ({ commit }, payload) => {
  const proxy = new PostSimpatraServiceProxy();
  const { vendorId } = payload;
  const body = {
    vendorId: payload.vendorId,
    tierName: payload.tierName,
    isHidden: payload.isHidden,
  };

  const query = `products/v1/vendor/${vendorId}/tier`;
  const notificationParams = {
    displaySuccessMessage: true,
    successNotificationMsg: "Successfully added tier!",
  };
  const response = await proxy.execute(query, body, notificationParams);
  if (response) {
    const { data } = response;
    commit("updateVendorTiers", { isAdd: true, data });
  }
};

const deleteVendorTier = async ({ commit }, payload) => {
  const { vendorId } = payload;
  const { tierId } = payload;

  const proxy = new DeleteSimpatraServiceProxy();
  const query = `/products/v1/vendor/${vendorId}/tier/${tierId}`;
  await proxy.execute(query, {
    notificationParams: {
      displaySuccessMessage: true,
      successNotificationMsg: "Successfully deleted tier!",
    },
  });
  commit("updateVendorTiers", { isDelete: true, id: tierId });
};

const saveProductPricing = async (_, { vendorId, productId, tierId, payload }) => {
  const proxy = new PutSimpatraServiceProxy();
  const query = `products/v1/vendor/${vendorId}/product/${productId}/tier/${tierId}/product-pricing`;
  const response = await proxy.execute(query, payload, {
    displaySuccessMessage: true,
    successNotificationMsg: "Successfully updated pricing!",
  });
  return response.data || null;
};

const deleteProductPricingInTier = async (_, payload) => {
  const { vendorId } = payload;
  const { productId } = payload;
  const { tierId } = payload;

  const proxy = new DeleteSimpatraServiceProxy();
  const query = `products/v1/vendor/${vendorId}/product/${productId}/tier/${tierId}`;
  return await proxy.execute(query, {
    notificationParams: {
      displaySuccessMessage: true,
      successNotificationMsg: "Successfully deleted pricing!",
    },
  });
};

export default {
  updateProduct,
  updateProductStocksStatus,
  addNewProduct,
  addNewBundleProduct,
  fetchVendorProducts,
  fetchVendorProductByProductId,
  fetchVendorTiers,
  addVendorTier,
  deleteVendorTier,
  saveProductPricing,
  deleteProductPricingInTier,
};
